export const READY = "WEB_VIEW:READY";
export const DOCUMENT_READY = "WEBVIEW:DOCUMENT:EVENT:READY";
export const WINDOW_LOAD = "WEBVIEW:WINDOW:EVENT:LOAD";
export const RESIZE = "WEBVIEW:WINDOW:VIEWPORT:RESIZE";
export const POST_CP = "WEBVIEW:CP:POST";
export const OMNITURE_TRACKING = "WEBVIEW:TRACKING:OMNITURE";
export const TRACK_PAGEVIEW = "WEBVIEW:TRACKING:PAGEVIEW";
export const UPDATE_LOCATION = "WEBVIEW:UPDATE_LOCATION";